import { IM190BrandOverviewModule } from '~/lib/data-contract';
import Link from '~/shared/components/Link/Link';

import styles from './m190LogoWall.module.css';

import { M190BrandLogo } from '../M190BrandLogo/M190BrandLogo';

export type M190LogoWallProps = Pick<IM190BrandOverviewModule, 'brands'>;

export const M190LogoWall = ({ brands }: M190LogoWallProps) => {
	return (
		<ul className={styles.root}>
			{brands.map(({ brandNo, link: { url, ...rest } }) => (
				<li key={brandNo}>
					<Link
						className={styles.link}
						href={url}
						isCustomStyle
						{...rest}
					>
						<div className={styles.aspectRatio}>
							<div className={styles.linkContent}>
								<M190BrandLogo brandNo={brandNo} />
							</div>
						</div>
					</Link>
				</li>
			))}
		</ul>
	);
};
